import safeStorage from './safeStorage';
import { delete_cookie } from './setCookie';

// Keys the old "remember me" login (2018, removed for good in PANEL-1606) wrote to localStorage:
// the member's email and PLAIN-TEXT password, plus the checkbox state. An old reducer also kept the
// member's email under `username`. Nothing on the portal origin writes or reads these keys any more
// (git history: only localStorage, never sessionStorage), but browsers that used those releases still
// hold them, so they are removed at every app start (PANEL-1611) — idempotent and four calls, so no
// "already wiped" marker. Do not reuse these key names for new features: this wipe would erase them.
export const LEGACY_CREDENTIAL_KEYS = ['password', 'email', 'checked', 'username'];

// Other leftovers that are not remember-me credentials: `captcha`, the last reCAPTCHA response token
// Login kept after the login it was solved for.
export const LEGACY_STORAGE_KEYS = ['captcha'];

// The `user` and `translator` cookies: older releases wrote the member's profile into them for 365
// days, and nothing read them (PANEL-1628). Always written with path=/ (setCookie ignores any other
// path), so one path=/ expiry removes each.
export const LEGACY_PROFILE_COOKIES = ['user', 'translator'];

// safeStorage swallows a blocked or missing localStorage, so this never throws at bootstrap.
export const wipeLegacyCredentials = () => {
  LEGACY_CREDENTIAL_KEYS.forEach((key) => safeStorage.removeItem(key));
  LEGACY_STORAGE_KEYS.forEach((key) => safeStorage.removeItem(key));
  // A sandboxed document throws on document.cookie; a leftover cookie is not worth a blank page.
  try {
    LEGACY_PROFILE_COOKIES.forEach((name) => delete_cookie(name));
  } catch (e) {
    // nothing to remove where cookies cannot be written
  }
};
